import { XDropdownSearchSelection } from '@adornis/popover/x-dropdown-search-selection.js';
import { customElement, property } from 'lit/decorators.js';

/*
 * @element tr-dropdown-search-selection
 */
@customElement('tr-dropdown-search-selection')
export class TrDropdownSearchSelection<T, V> extends XDropdownSearchSelection<T, V> {
  @property({ attribute: 'empty-state-with-search' }) emptyStateWithSearch?: string;
  @property({ attribute: 'empty-state-without-search' }) emptyStateWithoutSearch?: string;

  // @ts-ignore this should be fine
  override get emptyState() {
    const emptyState = this._searchString.value ? this.emptyStateWithSearch : this.emptyStateWithoutSearch;
    return emptyState ?? '';
  }

  override set emptyState(value: string) {}
}
